import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PrivateRoute = () => {
  const { user } = useSelector(s => s.auth);
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export const PublicRoute = () => {
  const { user } = useSelector(s => s.auth);
  return user ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export const RoleRoute = ({ roles }) => {
  const { user } = useSelector(s => s.auth);
  return roles.includes(user?.role) ? <Outlet /> : <Navigate to="/dashboard" replace />;
};
